<footer class="main-footer">
  <div class="container d-flex align-items-center justify-content-between">
    <div class="footer-container">
      <ul class="footer-links">
        <li><a href="https://triarqhealth.com/privacy-policy/" target="_blank">Privacy Policy</a></li>
        <!-- <li><a routerLink="/api-terms-of-use">Terms Of Use</a></li> -->
      </ul>
      <div class="footer-info"> © Copyright TRIARQ Health 2025. All Rights Reserved.</div>
    </div>
    <ul class="footer-links">
      <li><a href="https://files.triarqclouds.com/TRIARQ%20QSuite%20Disclosure%20Transparency%20Statement%2012%2007%2017.pdf" target="_blank">Mandatory Disclosures & Costs</a></li>
    </ul>
  </div>
</footer>
